<template>
  <div class="stats-bar">
    <BaseContainer>
      <div class="stats-bar__wrapper">
        <article class="card-stats" v-for="item in items" v-bind:data="item" v-bind:key="item.id">
          <div class="card-stats__wrapper">
            <TextLine class="card-stats__title" color="white" bold>{{ item.title }}</TextLine>
            <TextLine class="card-stats__subtitle" color="white">{{ item.subtitle }}</TextLine>
          </div>
          <TextLine class="card-stats__details" color="white">{{ item.details }}</TextLine>
        </article>
      </div>
    </BaseContainer>
  </div>
</template>

<script>
import TextLine from '../elements/TextLine.vue'
import BaseContainer from '../elements/BaseContainer.vue'
export default {
  name: 'StatsBar',
  components: { BaseContainer, TextLine },
  data() {
    return {
      items: [
        {
          title: '+4.8%',
          subtitle: '',
          details: 'Group like-for-like (LFL) sales (exc. fuel)'
        },
        {
          title: '£406m',
          subtitle: '+8.6%',
          details: 'Adjusted profit before tax'
        },
        {
          title: '£17.7bn',
          subtitle: '+2.7%',
          details: 'Group revenue'
        },
        {
          title: '£265m',
          subtitle: '',
          details: 'Free cash flow'
        }
      ]
    }
  }
}
</script>

<style lang="postcss">
.stats-bar {
  @apply bg-gradient-tl-primary;
}
.stats-bar__wrapper {
  @apply flex flex-wrap justify-around py-4;
}
@screen md {
  .stats-bar__wrapper {
    @apply flex-no-wrap py-8;
  }
}
.card-stats {
  @apply flex flex-col items-center p-4 flex-1;
  flex-basis: 40%;
}
.card-stats__wrapper {
  @apply flex items-baseline;
}
.card-stats__title {
  @apply px-1 text-3xl;
}
.card-stats__subtitle {
  @apply text-lg;
}
.card-stats__details {
  @apply text-sm text-center tracking-wide w-full;
}
@screen md {
  .card-stats {
    @apply py-0;
    flex-basis: 25%;
  }
}
@screen lg {
  .card-stats__title {
    @apply px-2 text-6xl;
  }
  .card-stats__subtitle {
    @apply text-xl;
  }
  .card-stats__details {
    @apply text-base;
  }
}
</style>
